import {loginUserStore} from "../../store/Login/LoginUserStore";
import {globalStore} from "../../store/GlobalStore";

export function adminApiErrorHandling(err: any): Promise<any> {
  if (err.status == 403) {
    loginUserStore.logout();
    return Promise.resolve(err);
  }

  if (err.status == 500) {
    globalStore.setServerError(true);
    return Promise.resolve(err); // 後続のcatchブロックをスキップ
  }

  return Promise.reject(err);
}
